import { useCache, CACHE_KEY } from '@/hooks/web/useCache'

// TokenType 接口定义
interface TokenType {
  id: number
  accessToken: string
  refreshToken: string
  userId: number
  userType: number
  clientId: string
  expiresTime: number
}

const { wsCache } = useCache()

const AccessTokenKey = 'ACCESS_TOKEN'
const RefreshTokenKey = 'REFRESH_TOKEN'

// 获取token
export const getAccessToken = () => {
  // 此处与TokenKey相同，此写法解决初始化时Cookies中不存在TokenKey报错
  const accessToken = wsCache.get(AccessTokenKey)
  return accessToken ? accessToken : wsCache.get('ACCESS_TOKEN')
}

// getToken 别名（兼容性）
export const getToken = getAccessToken

// 刷新token
export const getRefreshToken = () => {
  return wsCache.get(RefreshTokenKey)
}

// 设置token
export const setToken = (token: TokenType) => {
  wsCache.set(RefreshTokenKey, token.refreshToken)
  wsCache.set(AccessTokenKey, token.accessToken)
}

// 设置刷新token（单独设置）
export const setRefreshToken = (token: string) => {
  wsCache.set(RefreshTokenKey, token)
}

// 设置访问token（单独设置）
export const setAccessToken = (token: string) => {
  wsCache.set(AccessTokenKey, token)
}

// 删除token
export const removeToken = () => {
  wsCache.delete(AccessTokenKey)
  wsCache.delete(RefreshTokenKey)
}

/** 格式化token（jwt格式） */
export const formatToken = (token: string): string => {
  return 'Bearer ' + token
}

// ========== 租户相关 ==========

export const getTenantId = () => {
  return wsCache.get(CACHE_KEY.TenantId)
}

export const setTenantId = (tenantId: number) => {
  wsCache.set(CACHE_KEY.TenantId, tenantId)
}

export const getVisitTenantId = () => {
  return wsCache.get(CACHE_KEY.VisitTenantId)
}

export const setVisitTenantId = (visitTenantId: number) => {
  wsCache.set(CACHE_KEY.VisitTenantId, visitTenantId)
}

// ========== 用户相关 ==========

// 获取登录用户ID
export const getLoginId = (): number | null => {
  const token = getAccessToken()
  if (!token) return null
  
  try {
    // 解析 JWT token 获取用户ID
    const tokenParts = token.split('.')
    if (tokenParts.length === 3) {
      const payload = JSON.parse(atob(tokenParts[1]))
      return payload.userId || payload.uid || payload.id || null
    }
  } catch (error) {
    console.error('解析 token 失败:', error)
  }
  
  return null
}
